(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-builder"] && !Shopify.designMode) return;
  try {
    
(() => {
  const sortCabazes = (scope = document) => {
    scope.querySelectorAll('[data-cabaz-price-sort]').forEach(grid => {
      const cards = Array.from(grid.children).filter(card => card.matches('.bundle-card'));
      const ranked = cards.map((card, index) => {
        const value = card.querySelector('[data-card-price-cents]')?.getAttribute('data-card-price-cents');
        const price = value !== null && value !== undefined && /^\d+$/.test(value) ? Number(value) : Infinity;
        return {card, price, index};
      }).sort((a, b) => a.price - b.price || a.index - b.index);
      if (ranked.some((item, index) => item.card !== cards[index])) {
        ranked.forEach(item => grid.appendChild(item.card));
      }
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => sortCabazes(), {once: true});
  } else {
    sortCabazes();
  }
  document.addEventListener('shopify:section:load', event => sortCabazes(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
